module.exports = __webpack_public_path__ + "img/hr-dead-grey-trunk-02.f22e03bb.png";